module.exports = __webpack_public_path__ + "img/p5-2-2.ad3e8a1c.png";